import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import  { WebPubSubClient } from '@azure/web-pubsub-client';
import VehicleListV2 from './VehicleListV2';
import apiClient from './services/apiClient.js';
import SingleVehicleModalV2 from './SingleVehicleModalV2.jsx'

const Dashboard = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [client, setClient] = useState(null);
  const [isLoadingPubsubClient, _setIsLoadingPubsubClient] = useState(false);
  const isLoadingPubsubClientRef = React.useRef(isLoadingPubsubClient);

  const setIsLoadingPubsubClient = data => {
    isLoadingPubsubClientRef.current = data;
    _setIsLoadingPubsubClient(data);
  };

  //need to get the groupname from login 
  const intialiseWebPubSubClient = async () => {
     if (!isAuthenticated || user['/roles'].length === 0) {
        return;
     }

    const accessToken = await getAccessTokenSilently({
        authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
          }
      });
    const userRole = user['/roles'][0];
      const params = {
         user: user.email,
         groupName: userRole
       }

      const result = await apiClient.getPubSubClientAccessUrlAsync(params, accessToken)
      const webClient = new WebPubSubClient({
          getClientAccessUrl: async () => {
            return result.connectionUrl;
          }
        });
      await webClient.start();
      await webClient.joinGroup(userRole);

      setClient(webClient);
      setIsLoadingPubsubClient(false);
      console.log('pubsub client loading done!');
  }

    useEffect(() => {
        if(isAuthenticated)
        {
          setIsLoadingPubsubClient(true);
          intialiseWebPubSubClient();
        }
      
    }, [isAuthenticated]);

    const loadingSpinner = isLoadingPubsubClient ? 
    (
        <div className="d-flex justify-content-center align-items-center py-5">
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status" style={{width: '3rem', height: '3rem', color: '#1E70E0'}}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mb-0">Connecting to vehicle monitoring system...</p>
            </div>
        </div>
    ): null;

     if (!isAuthenticated || user['/roles'].length === 0){
      return (<div className="dashboard-content">Unauthorised!</div>)
    }

    return (
        <div className="dashboard-content" style={{paddingTop: '80px'}}>
            {loadingSpinner}
            <SingleVehicleModalV2 groupName='servo1'/>
            {client && (
                <div className="container-fluid px-4 pt-0 pb-4">
                    <VehicleListV2 client={client} groupName='servo1'/>
                </div>
            )}
        </div>
    )

    return null;
}

export default Dashboard;